<template>
    <div class="body-panel dataContent">

        <div class="body-panel-control separator" v-if="info.User && (hasClaims(info.User.DynamicRole, claimEnums.tasksEdit) || hasClaims(info.User.DynamicRole, claimEnums.tasksController) || info.User.MainRole === 'administrators' || info.ProjectsLength > 1)">
            <div class="control-block-left">
                <div class="flex">
                    <project-select :user="info.User" @onChange="onProjectChange" v-if="info.User && (info.User.MainRole === 'administrators' || info.ProjectsLength > 1)"></project-select>
                </div>
            </div>
            <div class="control-block-right" >
                <div class="btns flex" data-toggle="buttons">
                    <button class="btn btn-news" v-if="hasClaimsOrAdmin(info.User, claimEnums.tasksEdit)" @click="addTask">Добавить задание</button>
                    <button class="btn btn-news" @click="tasksTable">Ответы на задания</button>
                </div>
            </div>
        </div>
        <div class="body-panel-content body-panel-content-page panel-block-news">
            <div class="flex body-panel-content-center margin-bottom-20" data-toggle="buttons">
                <button type="button" :class="['btn-switcher', {'active': !tasksCompleted}]" @click="onTasksCompleted(0)">
                    Актуальные
                </button>
                <button type="button" :class="['btn-switcher', {'active': tasksCompleted}]" @click="onTasksCompleted(1)">
                    Завершенные
                </button>
            </div>
            <div class="body-panel-content-center">
                <div :class="['panel-block', 'panel-block-large']" v-for="(item, i) of tasks" :data-id="item.Id">
                    <div class="panel-block-info" style="border-top:none" @click="onItemClick(item.Id)">
                        <div class="flex margin-bottom-10">
                            <div style="width:100%">
                                <p :class="['tasks-header', { 'short': item.TaskType === TaskTypes.Cumulative }]">{{ item.Name }}</p>
                            </div>
                            <div v-if="item.ScoringAccrual === ScoringAccrualTypes.DependingOnSku || item.ScoringAccrualSumText!=='0'" class="tasks-tile-right">
                                <div style="text-align:right" :title="[onScoringAccrualSum(item)]">
                                    <svg class="svg-big tasks-svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <use xlink:href="/Content/dist/image_svg.svg?v2#RewardPoints"></use>
                                    </svg>
                                    <span class="tasks-balls">{{onScoringAccrualSum(item)}}</span>
                                </div>
                                <div>
                                    <p class="input-text-lbl" style="text-align:right" :title="[item.ScoringAccrualText]">{{item.ScoringAccrualText}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="flex" v-if="item.TaskType === TaskTypes.Simple" style="padding-top:3px">
                            <div style="width:50%">
                                <p class="input-text-lbl">{{item.StateText}}</p>
                            </div>
                            <div style="width:50%">
                                <p style="text-align:right">Выполнено: {{item.QntDone}}</p>
                            </div>
                        </div>
                        <div v-if="item.TaskType === TaskTypes.Cumulative">
                            <p class="input-text-lbl" v-if="item.TaskType === TaskTypes.Cumulative">{{item.StateText}}</p>
                            <div class="tasks-progress margin-top-5">
                                <div class="tasks-progress-line" :style="{width: item.QntDone + '%'}"></div>
                            </div>
                            <div class="flex margin-top-5">
                                <div style="width:50%">
                                    <p class="input-text-lbl">План: {{item.PurposeValue}}</p>
                                </div>
                                <div style="width:50%">
                                    <p style="text-align:right">Факт: {{item.Fact}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="panel-body-actions" v-if="info.User && (hasClaims(info.User.DynamicRole, claimEnums.tasksEdit) || info.User.MainRole === 'administrators')">
                        <button class="btn btn-img" @click="onEditTask(item.Id)" style="height:40px" title="Настройки задания">
                            <svg class="svg-icon svg-big" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <use xlink:href="/Content/dist/image_svg.svg?v2#Setting"></use>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <vue-headful :title="getPageTitle()" />
    </div>
</template>

<script>
    import $ from 'jquery';
    import UI from '../helpers/ui-helpers';
    import BackendApi from '../backendApi';
    import projectMixin from '../helpers/project-mixin';
    import _ from 'lodash';
    import moment from 'moment';
    import { TaskTypes, PurposeType, ScoringAccrualTypes } from '../enums';

    let backendApi = new BackendApi();
    let cacheKey = 'tasks';
    let DateTypes = {
        /* Дата заполнения */
        FillingDate: 1,
        /* Дата отчета */
        ReportDate: 2,
        /* Дата изменения статуса */
        StatusDate: 3
    };

    export default {
        name: "sku",

        props: ['info'],

        mixins: [projectMixin], // projectId

        data() {
            return {
                tasks: [],
                tasksCompleted: false,
                loading: false,
                canBeLoaded: true,
                page: 1,
                rowsPerPage: 20,
                projectId: null,
                search: null,
                active: true,
                importResult: null,
                groups: [],
                groupsOrigin: null,
                lastGroupId: null,
                scrollTop: null,
                firstLoad: true,
                emptyResults: false,
                statusId: DateTypes.FillingDate,
                dateTypeId: null,
                dateStart: null,
                dateEnd: null,
                statuses: [
                    { Id: 0, Name: 'Все ответы' }, { Id: 1, Name: 'Ждут проверки' }, { Id: 2, Name: 'Проверенные' },
                    { Id: 3, Name: 'Доработанные' }, { Id: 4, Name: 'На доработке' }, { Id: 5, Name: 'Отклоненные' },
                ],
                dateTypes: [
                    { Id: DateTypes.FillingDate, Name: ' Дата заполнения' },
                    { Id: DateTypes.ReportDate, Name: 'Дата отчета' },
                    { Id: DateTypes.StatusDate, Name: 'Дата изменения статуса' }
                ],
                TaskTypes: TaskTypes,
                PurposeType: PurposeType,
                ScoringAccrualTypes: ScoringAccrualTypes
            }
        },

        computed: {
        },

        watch: {
            '$route.query.folderId'(to, from) {
                this.reload();
            }
        },

        methods: {

            onTasksCompleted(paramcompleted) {
                this.tasksCompleted = paramcompleted === 1;
                this.reload();
            },

            onItemClick(id) {
                this.saveFilterState();
                this.$router.push('/tasks/' + id);
            },

            addTask() {
                this.saveFilterState();
                this.$router.push('/tasks/edit/' + this.projectId + '/0');
            },

            onEditTask(id) {
                this.saveFilterState();
                this.$router.push('/tasks/edit/' + this.projectId + '/' + id);
            },

            tasksTable() {
                this.saveFilterState();
                this.$router.push('/tasks/table');
            },

            onScoringAccrualSum(item) {
                let vm = this;
                return '+' + item.ScoringAccrualSumText;
                //return '+' + item.ScoringAccrualSum + (item.ScoringAccrual === vm.ScoringAccrualTypes.SumPercent ? '%' : '');
            },

            reload() {
                let vm = this;

                this.page = 1;
                this.loading = false;
                this.canBeLoaded = true;
                this.EndDate = [];
                this.tasks = [];
                //this.lastGroupId = null;
                this.firstLoad = true;
                this.emptyResults = false;

                //Promise.all([this.loadSettings(), this.loadGroups()]).then(function () {
                //    if (!vm.loading && vm.canBeLoaded) {
                //        vm.loadNext();
                //    }
                //});
                this.loadNext();
            },

            loadNext() {
                let vm = this;
                this.loading = true;
                let skip = (vm.page - 1) * vm.rowsPerPage;
                let take = vm.rowsPerPage;
                if (vm.firstLoad && vm.page > 1) {
                    skip = 0;
                    take = vm.page * vm.rowsPerPage;
                }

                if (vm.info.User.MainRole !== 'administrators') {
                    if (!vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.tasksPage)) {
                        this.$router.push('/');
                        return;
                    }
                    //if (!vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.tasksEdit) && vm.hasClaims(vm.info.User.DynamicRole, vm.claimEnums.tasksController)) {
                    //    this.tasksTable();
                    //    return;
                    //}
                }
                UI.blockUI('.dataContent', 'Загрузка...');

                this.callApiWrapper(backendApi.tasksList(skip, take, vm.projectId, vm.tasksCompleted ? 1 : 0))
                    .then(function (resp) {
                        if (resp.hasError) {
                            UI.toastr.error('Ошибка во время загрузки заданий');
                        }
                        else if (resp.data.tasks && resp.data.tasks.length) {

                            vm.tasks.push(...resp.data.tasks);

                            if (vm.firstLoad) {
                                vm.firstLoad = false;
                                if (vm.scrollTop) {
                                    $('.body-panel-content').animate({ scrollTop: vm.scrollTop }, 500);
                                }
                            }
                        }
                        else {
                            vm.canBeLoaded = false;
                            if (vm.search && !vm.sku.length) {
                                vm.emptyResults = true;
                            }
                        }
                        UI.unblockUI('.dataContent');
                        vm.loading = false;
                    })
                    .catch(function (err) {
                        console.info('err', err)
                        UI.toastr.error('Ошибка во время загрузки');
                    })
            },

            onProjectChange(item) {
                this.projectId = item.Id;
                if(this.$route.query.folderId){
                    this.$router.replace({query: {}});
                }
                this.reload();
                this.$emit('user-updated');
            },

            onStatusChange() {
                this.reload();
            },

            onDateChange() {
                this.reload();
            },

            clearFilterState() {
                localStorage.removeItem(cacheKey);
            },

            saveFilterState() {
                //console.info('this.statusId:', this.statusId);

                let stateObj = {
                    statusId: this.statusId,
                    dateTypeId: this.dateTypeId,
                    dateStart: this.dateStart,
                    dateEnd: this.dateEnd,
                    page: this.page,
                    scrollTop: this.scrollTop,
                    tasksCompleted: this.tasksCompleted
                };
                localStorage.setItem(cacheKey, JSON.stringify(stateObj));
            },

            recoverFilterState() {
                let stateObj = JSON.parse(localStorage.getItem(cacheKey));
                //console.info('recoverFilterState -> stateObj:', stateObj);
                if (stateObj) {
                    if (stateObj.statusId != null) {
                        this.statusId = stateObj.statusId;
                    }
                    if (stateObj.dateTypeId) {
                        this.dateTypeId = stateObj.dateTypeId;
                    }
                    if (stateObj.dateStart) {
                        this.dateStart = stateObj.dateStart;
                    }
                    if (stateObj.dateEnd) {
                        this.dateEnd = stateObj.dateEnd;
                    }
                    if (stateObj.page) {
                        this.page = stateObj.page;
                    }
                    if (stateObj.scrollTop) {
                        this.scrollTop = stateObj.scrollTop;
                    }
                    if(stateObj.tasksCompleted) {
                        this.tasksCompleted = stateObj.tasksCompleted;
                    }
                    this.clearFilterState();
                }
            },
        },

        mounted() {
            let vm = this;

            vm.recoverFilterState();

            vm.loadNext();

            vm.$nextTick(() => {

                $('.body-panel-content').on('scroll', function () {
                    let elem = $(this);
                    let scrollTop = elem.scrollTop();
                    vm.scrollTop = scrollTop;

                    if (!vm.loading && vm.canBeLoaded && !vm.firstLoad) {
                        //console.info('elem[0].scrollHeight - elem.scrollTop(), elem.outerHeight()', [elem[0].scrollHeight] - elem.scrollTop(), elem.outerHeight());
                        if (elem[0].scrollHeight - scrollTop - 700 <= elem.outerHeight()) {
                            vm.page++;
                            vm.loadNext();
                        }
                    }
                });
            });
        },

        destroyed() {
            $('.body-panel-content').off('scroll');
        }
    }
</script>


// WEBPACK FOOTER //
// Content/src/views/Tasks.vue